export class Project {
  constructor(private readonly uuid: string, private readonly id: number, private readonly name: string) {}

  getUUID() {
    return this.id;
  }

  getId() {
    return this.id;
  }

  getLabel() {
    return this.name;
  }

  toRawJson() {
    return {
      id: this.uuid,
      name: this.name,
    };
  }
}
